import React, { useContext } from 'react'

import GenericTable, {
  DataTableInterface,
} from '../../../../components/misc/GenericTable'
import { formatDate } from '../../../../utils/helpers'
import { RegisterDetailsContext } from '../RegisterDetailsContainer'

export const OperationsRegisterTab = () => {
  const { order } = useContext(RegisterDetailsContext)
  const tableTitles = ['Acción', 'Fecha', 'Realizada por', 'Detalles']
  const displayData: DataTableInterface[] = []

  if (order?.records) {
    order?.records.forEach((item) => {
      const payload: Record<
        string,
        string | number | boolean | React.ReactNode
      > = {
        Acción: (
          <div>
            <p className="max-w-xs text-ellipsis break-words text-center text-sm font-medium text-gray-900">
              {item?.title}
            </p>
          </div>
        ),
        'Realizada por': (
          <div>
            <p className="max-w-xs text-ellipsis break-words text-center text-sm text-gray-500">
              {item?.madeBy?.displayName}
            </p>
          </div>
        ),
        Fecha: (
          <div>
            <p className="max-w-xs text-ellipsis break-words text-center text-sm text-gray-500">
              {formatDate(item?.createdAt)}
            </p>
          </div>
        ),
        Detalles: (
          <div>
            <p className="max-w-xs text-ellipsis break-words text-justify text-sm text-gray-500">
              {item?.details ?? '-'}
            </p>
          </div>
        ),
      }
      displayData.push({ deletedRow: false, payload: payload })
    })
  }

  return (
    <div className="h-[26rem] overflow-y-auto px-3">
      <GenericTable tableData={displayData} tableTitles={tableTitles} />
    </div>
  )
}
